import script from "./UsuarioProximasReservas.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioProximasReservas.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioProximasReservas.vue?vue&type=style&index=0&id=30ea5f8e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30ea5f8e"]])

export default __exports__